'use strict';

module.exports = function (body) {
  try {
    body = JSON.parse(body);
  } catch (e) { /* ignored */ }

  return body;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/braintree-web/client/request/parse-body.js
// module id = 165
// module chunks = 0